import { useEffect, useState } from 'react';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/99dd1a0b669542582fd61bec25de6a10.jpg"
          alt="Workshop"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-8 flex flex-col items-center" style={{ marginTop: '-10vh' }}>
        {/* Badge */}
        <div
          className={`inline-block border-2 border-[#8B6914] px-4 sm:px-6 py-2 rounded-full mb-6 sm:mb-8 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <span className="text-[#8B6914] text-[10px] sm:text-xs uppercase tracking-widest font-semibold">
            HANDCRAFTED | BATTLE-READY
          </span>
        </div>

        {/* Main Headline */}
        <h1
          className={`text-[48px] sm:text-[72px] lg:text-[92px] font-black text-[#F7F7F7] leading-none mb-4 sm:mb-6 transition-all duration-1000 delay-200 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ letterSpacing: '-2px', textShadow: '0 4px 20px rgba(0,0,0,0.8)' }}
        >
          DARK WARRIOR
          <br />
          WEAPONS
        </h1>

        {/* Subheadline */}
        <p
          className={`text-base sm:text-xl text-[#A0AEC0] mb-8 sm:mb-12 transition-all duration-1000 delay-500 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Forged with Purpose. Built to Last.
        </p>

        {/* CTA Buttons */}
        <div
          className={`flex flex-col sm:flex-row gap-4 sm:gap-6 w-full sm:w-auto px-4 sm:px-0 transition-all duration-1000 delay-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <button
            onClick={() => scrollToSection('products')}
            className="bg-[#8B6914] text-white px-8 sm:px-10 py-4 rounded-xl text-sm sm:text-base font-bold hover:bg-[#6B4423] transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
          >
            EXPLORE ARSENAL
            <i className="ri-sword-line text-xl"></i>
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="border-2 border-[#8B6914] text-[#8B6914] px-8 sm:px-10 py-4 rounded-xl text-sm sm:text-base font-bold hover:bg-[#8B6914] hover:text-white transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            OUR STORY
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-[#8B6914] text-3xl"></i>
      </div>
    </section>
  );
}
